// src/pages/MentionsLegales.js - Mentions Légales
import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

function MentionsLegales() {
  return (
    <div className="legal-container">
      <div className="legal-card">
        <div className="legal-header">
          <h1>⚖️ Mentions Légales</h1>
          <p className="legal-date">Dernière mise à jour : Juillet 2026</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>1. Éditeur du Site</h2>
            <p>Le site <strong>www.firstarabic.com</strong> est édité par :</p>
            <div className="info-block">
              <p><strong>FirstArabic</strong></p>
              <p>Statut : Entreprise individuelle / Auto-entrepreneur</p>
              <p>Siège social : 113 boulevard de Strasbourg, 76600 Le Havre, France</p>
              <p>SIRET : 982 583 304 00026</p>
              <p>N° TVA intracommunautaire : FR46982583304</p>
              <p>Email : <a href="mailto:contact@firstarabic.com">contact@firstarabic.com</a></p>
              <p>Téléphone : [À COMPLÉTER]</p>
              <p>Directeur de la publication : Jamal Marouane</p>
            </div>
          </section>

          <section>
            <h2>2. Hébergement</h2>
            <p>Le site est hébergé par :</p>
            <div className="info-block">
              <p><strong>Vercel Inc.</strong></p>
              <p>340 S Lemon Ave #4133</p>
              <p>Walnut, CA 91789, États-Unis</p>
              <p>Site web : <a href="https://vercel.com" target="_blank" rel="noopener noreferrer">www.vercel.com</a></p>
            </div>
          </section>

          <section>
            <h2>3. Propriété Intellectuelle</h2>
            <p>
              L'ensemble du contenu du site FirstArabic (textes, images, logo, design, 
              fonctionnalités, bases de données) est protégé par le droit de la propriété 
              intellectuelle et appartient à FirstArabic ou fait l'objet d'une autorisation 
              d'utilisation.
            </p>
            <p>
              Toute reproduction, représentation, modification, publication, adaptation de tout 
              ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, 
              est interdite, sauf autorisation écrite préalable de FirstArabic.
            </p>
          </section>

          <section>
            <h2>4. Données Personnelles</h2>
            <p>
              FirstArabic collecte et traite des données personnelles conformément au Règlement 
              Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
            </p>
            <p>
              Pour plus d'informations sur la collecte et le traitement de vos données, 
              consultez notre <Link to="/confidentialite">Politique de Confidentialité</Link>.
            </p>
            <p>
              Conformément à la réglementation, vous disposez d'un droit d'accès, de rectification, 
              de suppression et d'opposition aux données vous concernant. Pour exercer ces droits, 
              contactez-nous à : <a href="mailto:contact@firstarabic.com">contact@firstarabic.com</a>
            </p>
          </section>

          <section>
            <h2>5. Cookies</h2>
            <p>
              Le site FirstArabic utilise des cookies pour améliorer l'expérience utilisateur 
              et assurer le bon fonctionnement des services. Ces cookies sont essentiels au 
              fonctionnement du site (authentification, session).
            </p>
            <p>
              Vous pouvez configurer votre navigateur pour refuser les cookies. Toutefois, 
              certaines fonctionnalités du site pourraient ne plus fonctionner correctement.
            </p>
          </section>

          <section>
            <h2>6. Responsabilité</h2>
            <p>
              FirstArabic s'efforce d'assurer l'exactitude et la mise à jour des informations 
              diffusées sur le site. Toutefois, FirstArabic ne peut garantir l'exactitude, 
              la précision ou l'exhaustivité des informations mises à disposition.
            </p>
            <p>
              FirstArabic décline toute responsabilité :
            </p>
            <ul>
              <li>Pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site</li>
              <li>Pour tous dommages résultant d'une intrusion frauduleuse d'un tiers</li>
              <li>Pour tout dommage causé par une interruption ou un dysfonctionnement du site</li>
            </ul>
          </section>

          <section>
            <h2>7. Liens Hypertextes</h2>
            <p>
              Le site peut contenir des liens vers d'autres sites. FirstArabic n'exerce aucun 
              contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>

          <section>
            <h2>8. Droit Applicable</h2>
            <p>
              Les présentes mentions légales sont régies par le droit français. En cas de litige, 
              et après échec de toute tentative de recherche d'une solution amiable, les tribunaux 
              français seront seuls compétents.
            </p>
          </section>

          <section>
            <h2>9. Médiation de la Consommation</h2>
            <p>
              Conformément aux articles L611-1 et suivants du Code de la consommation, tout
              consommateur a le droit de recourir gratuitement à un médiateur de la consommation
              en vue de la résolution amiable d'un litige l'opposant à FirstArabic, après avoir
              tenté au préalable de le résoudre directement auprès de notre service client.
            </p>
            <div className="info-block">
              <p><strong>Médiateur désigné :</strong> [NOM DU MÉDIATEUR À COMPLÉTER]</p>
              <p>Adresse : [ADRESSE DU MÉDIATEUR À COMPLÉTER]</p>
              <p>Site web : [URL DU MÉDIATEUR À COMPLÉTER]</p>
            </div>
            <p>
              L'adhésion à un dispositif de médiation de la consommation est une obligation
              légale pour tout professionnel vendant à des consommateurs. Ce champ doit être
              complété avant l'ouverture au public.
            </p>
          </section>

          <section>
            <h2>10. Contact</h2>
            <p>
              Pour toute question concernant ces mentions légales, vous pouvez nous contacter :
            </p>
            <ul>
              <li>Par email : <a href="mailto:contact@firstarabic.com">contact@firstarabic.com</a></li>
              <li>Via notre <Link to="/contact">formulaire de contact</Link></li>
            </ul>
          </section>
        </div>

        <div className="legal-footer">
          <Link to="/">← Retour à l'accueil</Link>
          <div className="legal-links">
            <Link to="/cgu">CGU</Link>
            <Link to="/confidentialite">Confidentialité</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MentionsLegales;
